import React, { useState, useMemo, useContext, useEffect } from 'react';
import { Link, NavLink, useMatch } from "react-router-dom";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const DataTableComponent = (props) => {
    const { sample, columns , loading} = props;
    // const [loading, setLoading] = useState(false);
  
    const columns_data = columns.map((col, i) => {
        // console.log("colum data from datatable ", col)
        return <Column key={col.field} field={col.field} header={col.header} />;
    });


    return (
        <div className="row">
            {(sample.length > 0) ?
                <DataTable
                    size="small"
                    scrollable
                    scrollHeight='500'
                    value={sample}
                    paginator={sample.length > 10 ? true : false}
                    rows={20}
                    loading={loading}
                    editMode="cell"
                    emptyMessage="Currently, you don't have any new Samples here.">
                    <Column selectionMode="multiple" headerStyle={{ width: '2rem' }}></Column>
                    <Column field="" header="Action"></Column>
                    {columns_data}
                </DataTable> :
                <DataTable value={[]} size="small" loading={loading} emptyMessage="Currently, you don't have any new Samples here.">
                    <Column selectionMode="multiple" headerStyle={{ width: '2rem' }}></Column>
                    <Column field="" header="Action"></Column>
                    <Column field="" header="Sample"></Column>
                    <Column field="" header="File 1"></Column>
                    <Column field="" header="File 1"></Column>
                    <Column field="" header="Attributes"></Column>
                </DataTable>
            }
        </div>
    );
}

export default DataTableComponent;
